import React, { useCallback, useEffect, useState } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';

import Banner from '../../../components/banner/Banner';
import { MobilePaddingLessContentWrapper } from '../../../styles/shared';
import { SingleStrapiImage } from '../../../models/domain/interfaces';
import { ProductJsonLd, ProductJsonLdProps } from 'next-seo';

interface IProps {
  banner: {
    title: string;
    description: string;
    image: SingleStrapiImage;
    mobileImage?: SingleStrapiImage;
    button: {
      text: string;
      url: string;
    };
    overlay: string;
    forceHideDescription?: boolean;
    forceHideButton?: boolean;
    forceHideBreadcrumb?: boolean;
    headerDescriptionPosition?: 'default' | 'under' | 'hidden';
    forceHideTitle?: boolean;
    forceDescriptionToBeWhite?: boolean;
    forceDescriptionToBeBlack?: boolean;
    headerCoverResize?: 'default_cover' | 'contain' | 'hidden';
  };
  breadCrumb?: {
    links: {
      href: string;
      name: string;
      color?: string;
    }[];
    pageActive: {
      color?: string;
      name: string;
    };
  };
  translations: any;
  productSchema: ProductJsonLdProps;
}

const Header: React.FC<{ data: IProps; isPrerenderRequest: boolean }> = ({
  data,
  isPrerenderRequest,
}: {
  data: IProps;
  isPrerenderRequest: boolean;
}) => {
  const [, setRerender] = useState<number>(0); // Trick to force re-render
  const [bannerState, setBannerState] = useState<any>(data?.banner);
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpointsMediaQuery.up('sm'));
  const banner = useCallback(() => {
    const image =
      typeof window === 'undefined' || isDesktop
        ? data?.banner?.image
        : data?.banner?.mobileImage?.data
          ? data?.banner?.mobileImage
          : data?.banner?.image;

    return {
      ...data?.banner,
      image,
    };
  }, [isDesktop, data.banner]);

  useEffect(() => {
    setRerender(Date.now());
  }, []);

  useEffect(() => {
    setBannerState(banner());
  }, [banner, isDesktop]);

  return (
    <MobilePaddingLessContentWrapper>
      <Banner
        {...bannerState}
        breadCrumb={data.breadCrumb}
        textLineLimit={false}
        isPrerenderRequest={isPrerenderRequest}
      />
      <ProductJsonLd {...(data?.productSchema || {})} />
    </MobilePaddingLessContentWrapper>
  );
};

export default Header;
